<template>
  <CustomCreateDialog
    dialogTitle="افزودن درس به کاربر"
    dialogId="add-lesson-to-user"
    okTitle="افزودن"
    :isOkDisabled="isOkButtonDisabled"
    @ok="addLessonToSelectedUser"
  >
    <BCol cols="12">
      <IndependentLessonPicker
        isInDialog
        :isMultiple="true"
        @getLesson="setLesson"
      ></IndependentLessonPicker>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["updateLessons"],
  props: {
    externalUserId: {
      type: [String, Number, null],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
      addLessonPayload: {
        userId: null,
        lessonIds: null,
      },
    };
  },
  methods: {
    setLesson(lessonIds) {
      this.addLessonPayload.lessonIds = lessonIds;
    },
    handleQueryParamsPayload() {
      let payload = {
        userId: this.addLessonPayload.userId,
      };
      if (
        this.addLessonPayload.lessonIds &&
        this.addLessonPayload.lessonIds.length > 0
      ) {
        for (let i = 0; i <= this.addLessonPayload.lessonIds.length; i++) {
          payload[`lessonIds[${i}]`] = this.addLessonPayload.lessonIds[i];
        }
      }
      return payload;
    },
    async addLessonToSelectedUser() {
      try {
        this.isOkButtonDisabled = true;
        this.addLessonPayload.userId = this.externalUserId;
        let _this = this;
        let addLessonToUserArray = new AddLessonToUserArray(_this);
        addLessonToUserArray.setRequestParam(_this.handleQueryParamsPayload());
        await addLessonToUserArray.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "اضافه شد",
                icon: "CheckIcon",
                variant: "success",
                text: "درس به کاربر اضافه شد.",
              },
            });
            this.$emit("updateLessons");
            _this.addLessonPayload = {
              userId: null,
              lessonIds: null,
            };
            this.$bvModal.hide("add-lesson-to-user");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    IndependentLessonPicker,
    BCol,
  },
};
import { AddLessonToUserArray } from "@/libs/Api/Order";
import IndependentLessonPicker from "./IndependentLessonPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import { BCol } from "bootstrap-vue";
</script>
